import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";
import "@bellomyinsightstech/app-shell/tokens.css";
import "@bellomyinsightstech/app-shell/styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { getRouter } from "./router";
import "./styles.css";
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } });
createRoot(document.getElementById("root")!).render(<StrictMode><QueryClientProvider client={queryClient}><AuthProvider><RouterProvider router={getRouter()} /><Toaster richColors position="top-right" /></AuthProvider></QueryClientProvider></StrictMode>);
